import { ReactElement } from 'react';

export const Register = (): ReactElement => {
  /* const { i18n, t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const { authApi } = useAuthApi();

  const { error, success } = useMessage();

  const navigate = useNavigate();

  const signup = (form: ISignupRequest) => {
    setLoading(true);
    authApi
      .registerUser(form)
      .then((resp) => {
        if (resp.status === 200) {
          navigate(ROUTES.login);
          //@ts-ignore
          success({ title: resp.data.message });
        } else {
          setErrors(buildErrorDetails(resp));
          buildErrorMessage(resp) && error({ title: buildErrorMessage(resp) });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const { bindTextField, bindSelect, submit, setErrors } = useForm<ISignupRequest>({ onSubmit: signup }); */

  return (
    <>
      {/* <Container maxWidth="sm">
      <Stack direction={'row'} alignItems="center" justifyContent={'center'} sx={{ mt: '20px' }}>
        <RegisterWrapper>
          <Stack direction={'column'} justifyContent={'center'} alignItems="center" spacing={3}>
            <Stack direction={'column'} alignItems="center" justifyContent={'center'}>
              <img src={''} alt="logo big" style={{ width: '100%' }} />
              <Typography fontWeight={600} fontSize={'20px'} color="secondary">
                {t('register.subTitle')}
              </Typography>
            </Stack>
            <Grid container spacing={3}>
              <Grid size={6}>
                <TextField label={t('register.email')} fullWidth {...bindTextField({ field: 'email' })} />
              </Grid>
              <Grid size={6}>
                <TextField label={t('register.role')} fullWidth {...bindSelect({ field: 'role', multiple: true })}>
                  <MenuItem value={'ROLE_ADMIN'}>admin</MenuItem>
                  <MenuItem value={'ROLE_USER'}>user</MenuItem>
                  <MenuItem value={'customer'}>customer</MenuItem>
                </TextField>
              </Grid>
              <Grid size={6}>
                <TextField label={t('register.firstName')} fullWidth {...bindTextField({ field: 'firstName' })} />
              </Grid>
              <Grid size={6}>
                <TextField label={t('register.lastName')} fullWidth {...bindTextField({ field: 'lastName' })} />
              </Grid>
              <Grid size={6}>
                <TextField label={t('register.username')} fullWidth {...bindTextField({ field: 'username' })} />
              </Grid>
              <Grid size={6}>
                <Password label={t('register.password')} fullWidth {...bindTextField({ field: 'password' })} />
              </Grid>
            </Grid>
            <Lang
              label={t('register.lang')}
              size="small"
              sx={{ width: '80%' }}
              fullWidth
              value={i18n.language}
              onChange={(e) => {
                i18n.changeLanguage(e.target.value);
              }}
            />
            <Button
              loading={loading}
              loadingPosition="end"
              variant="contained"
              size="large"
              onClick={submit}
              endIcon={<CheckCircleOutlineIcon />}
            >
              {t('actions.register')}
            </Button>
            <Stack direction="column" alignItems={'center'} spacing={1}>
              <Typography fontSize={'16px'}>
                {t('register.haveAccount')}{' '}
                <strong>
                  <Link onClick={() => navigate(ROUTES.login)}>{t('actions.login')}</Link>
                </strong>
              </Typography>
              <Typography fontSize={'13px'}>
                {t('register.help')}
                <strong>
                  <Link href="mailto:info@boh.com">info@boh.com</Link>
                </strong>
              </Typography>
            </Stack>
          </Stack>
        </RegisterWrapper>
      </Stack>
    </Container> */}
    </>
  );
};
